import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateRequestComponent } from '../../Admin/help-and-support/create-request/create-request.component';

export interface PlanFeature {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-professional-plan-announcement-dialog',
  templateUrl: './professional-plan-announcement-dialog.component.html',
  styleUrls: ['./professional-plan-announcement-dialog.component.css'],
  standalone: false
})
export class ProfessionalPlanAnnouncementDialogComponent implements OnInit {

  public dialogTitle: string = 'Welcome to the Professional Plan';
  public introText: string = "Your company is on the Professional Plan. Here's a quick overview:";

  public features: PlanFeature[] = [
    {
      icon: 'visibility_off',
      title: 'Hidden Mode',
      description: 'Tracker can run without a visible window. Not on Basic.'
    },
    {
      icon: 'photo_camera',
      title: 'App-Switch Screenshots',
      description: 'Captured when an employee switches apps.'
    },
    {
      icon: 'videocam',
      title: 'Screencast Viewing Limit',
      description: 'Up to 90 minutes per day.'
    },
    {
      icon: 'timer',
      title: 'Screenshot Interval',
      description: 'Minimum 10 minutes.'
    },
    {
      icon: 'date_range',
      title: 'Screenshot Retention',
      description: '30 days.'
    },
    {
      icon: 'history',
      title: 'Activity Log Retention',
      description: '90 days.'
    },
    {
      icon: 'groups',
      title: 'Team Management',
      description: 'Up to 10 teams.'
    }
  ];

  public webcamNotice: string = 'Not included. Off unless separately enabled.';
  public footerText: string = ''; // Not used directly since HTML has the link structure
  public primaryButtonText: string = 'Got It';
  public companyName: string = '';

  constructor(
    public dialogRef: MatDialogRef<ProfessionalPlanAnnouncementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {
    if (this.data && this.data.companyName) {
      this.companyName = this.data.companyName;
    }
  }

  ngOnInit(): void {
  }

  onGotItClick(): void {
    this.dialogRef.close(true);
  }

  onContactSupportClick(): void {
    // Open the Support Request modal component
    this.dialog.open(CreateRequestComponent, {
      width: '500px',
      maxWidth: '95vw',
      panelClass: 'create-request-modal',
      disableClose: true,
      data: { type: 'support', source: 'page' }
    });
  }

}
